export default __webpack_public_path__ + "static/media/automation2.c7be5c0e.jpg";